import { net } from "./pb";
import { BinaryEncoder, BinaryDecoder } from "./IMBinaryUtils";
import IMUtils from "./imUtils";
import { deviceid } from "@/uitls/uitls";
import SocketRes from "./SocketRes";
import Storage from "@/uitls/Storage";

const Socket = {
  ws: null,
  //重连倒计时
  hearbeat_interval: 15,
  //重连计时器
  hearbeatTime: null,
  //循环发送的计时器
  loopTime: null,
  //心跳的计时器
  heartbeatTime2: null,
  fastkey: null,

  uid: null,
  connectURL: null,
  cacheBuffer: null,
  packcount: 0,
  handlers: [],
  socketIps: [],
  socketPort: [],
  socketIndex: Storage.get("socketIndex", 0),
  nowSendTime: 0,
  serverTime: 0,
  HEART_TIME: 5000,
  MAX_HEART_TIME: 15000,

  preInit: (sks: string[], sps: number[], uid: number, fastkey: string) => {
    Socket.socketIps = sks;
    Socket.socketPort = sps;
    let ip = sks[Socket.socketIndex % sks.length];
    let port = sps[Socket.socketIndex % sps.length];
    const url = `wss://${ip}:${port}`;
    Socket.init(url, uid, fastkey);
  },

  init: (url, uid, fastkey) => {
    Socket.fastkey = fastkey;
    Socket.uid = uid;

    Socket.connectURL = url;
    if (!url || url == "") {
      console.log("socket连接是空的，去看看吧");
      return;
    }

    // 已经创建过连接不再重复创建
    if (Socket.ws && Socket.ws.readyState) {
      console.log("已经创建过连接不再重复创建");
      return;
    }
    console.log("连接了", url, uid, fastkey);
    Socket.ws = new WebSocket(Socket.connectURL);
    Socket.ws.binaryType = "arraybuffer";

    Socket.heartbeat();

    Socket.ws.onopen = (e) => {
      console.log("连接成功");
      Socket.packcount = 0;
      //Socket.reconnect();
      Socket.h5login();
      Storage.set("socketIndex", Socket.socketIndex);
    };
    Socket.ws.onclose = (e) => {
      console.log("onclose=======>");
      // Socket.reconnect();
    };
    Socket.ws.onerror = (e) => {
      console.log("onerror=====>");
      // Socket.reconnect(); 
    };

    Socket.ws.onmessage = (e) => {
      Socket.hearbeat_interval = 15;
      //收到通知
      let decoder = new BinaryDecoder(e.data);

      if (!Socket.cacheBuffer || Socket.cacheBuffer.length == 0) {
        Socket.cacheBuffer = decoder.getBinary();
      } else {
        const tempBuffer = decoder.getBinary();
        Socket.cacheBuffer = BinaryEncoder.concat(
          Socket.cacheBuffer,
          tempBuffer
        );
        decoder = new BinaryDecoder(Socket.cacheBuffer.buffer);
      }
      let cmdArr = new Array();
      let bodyArr = new Array();
      let uidArr = new Array();
      decoder.index = 0;
      let buffLen = decoder.arrayBuffer.byteLength - decoder.index;

      while (buffLen >= 8) {
        const uin = decoder.getInt32();
        const cmd = decoder.getInt16();
        const len = decoder.getUint16();

        if (len + 8 <= buffLen) {
          var body = decoder.getBinary(len);
          cmdArr.push(cmd);
          bodyArr[cmdArr.length - 1] = body;
          uidArr.push(uin);
          buffLen -= len + 8;
        } else {
          decoder.index -= 8;
          break;
        }
      }
      // this.reciveHeartTime = new Date().getTime();
      if (decoder.index < decoder.arrayBuffer.byteLength - 1) {
        Socket.cacheBuffer = decoder.getBinary();
      } else {
        Socket.cacheBuffer = null;
      }
      for (let index = 0; index < cmdArr.length; index++) {
        const cmd = cmdArr[index];
        const body = bodyArr[index];
        const uin = uidArr[index];
        for (let i = 0; i < Socket.handlers.length; i++) {
          const handler = Socket.handlers[i];
          if (handler.handle(cmd, body, uin)) {
            continue;
          }
        }
        //集中处理cmd
        SocketRes(cmd, body);

        if (cmd == net.CLIENT_MSG_ID.C2S_MSG_HEART) {
          const msg = net.msg_heart_test.decode(body);
          Socket.serverTime = msg.svr_time;
          Socket.nowSendTime = msg.svr_time;
        }
      }
    };
  },
  //   hearbeat_interval
  /**
   * 重新连接
   */
  reconnect: () => {
    if (Socket.hearbeatTime) {
      return;
    }
    Socket.hearbeatTime = setTimeout(() => {
      //Socket.hearbeat_interval--;
      //console.log('hearbeat_interval', Socket.hearbeat_interval);
      //if (Socket.hearbeat_interval < 0) {
      Socket.ws.close();
      Socket.ws = null;
      console.log("掉线重连了", Socket.connectURL);
      //Socket.hearbeat_interval = 5;
      Socket.socketIndex++;
      Socket.preInit(Socket.socketIps, Socket.socketPort, Socket.uid, Socket.fastkey);
      Socket.hearbeatTime = null;
      //}
    }, 3000);
  },
  clearHeartbeat: () => {
    clearInterval(Socket.heartbeatTime2);
    Socket.heartbeatTime2 = null;
  },
  //心跳
  heartbeat: () => {
    Socket.clearHeartbeat();
    Socket.heartbeatTime2 = setInterval(() => {
      Socket.nowSendTime += Socket.HEART_TIME;
      let t = Socket.nowSendTime - Socket.serverTime;
      // console.log("heartbeat", Socket.nowSendTime, Socket.serverTime, t)
      if (t > Socket.MAX_HEART_TIME) {
        Socket.nowSendTime = 0;
        Socket.serverTime = 0;
        Socket.hearbeat_interval = 0;
        Socket.clearHeartbeat();
        Socket.reconnect();
      } else {
        const msg = new net.msg_heart_test();
        msg.svr_time = 1;
        let buffer = net.msg_heart_test.encode(msg).finish();
        Socket.send(net.CLIENT_MSG_ID.C2S_MSG_HEART, buffer);
      }
    }, 5000);
  },
  h5login: () => {
    var msg = new net.msg_h5login_req();
    msg.uid = Socket.uid;
    // console.log("h5login的id是", msg.uid); 
    msg.fastkey = BinaryEncoder.fromString(Socket.fastkey);
    msg.deviceid = IMUtils.encode(deviceid("deviceid"));
    msg.version = IMUtils.encode("2.0");
    let buffer = net.msg_h5login_req.encode(msg).finish();
    Socket.send(net.CLIENT_MSG_ID.C2S_MSG_H5LOGIN, buffer);
  },
  send: (cmd, msg) => {
    const bufferMsg = {};
    bufferMsg[Socket.packcount] = msg;
    Socket.packcount++;
    const packcountBinary = BinaryEncoder.fromInt32(true, Socket.packcount);
    const cmdBinary = BinaryEncoder.fromInt16(true, cmd);
    const msgLenBinary = BinaryEncoder.fromInt16(true, msg.length);
    const msgData = BinaryEncoder.concat(
      packcountBinary,
      cmdBinary,
      msgLenBinary,
      msg
    );
    // 开启状态直接发送
     // 开启状态直接发送
    if (Socket.ws && Socket.ws.readyState === WebSocket.OPEN) {
      Socket.ws.send(msgData.buffer)
      // console.log("Socket发送成功");
    } else {
      // 正在开启状态，4秒后发送
      setTimeout(() => {
        if (Socket.ws && Socket.ws.readyState === WebSocket.OPEN) {
          if (Socket.ws && Socket.ws.readyState === WebSocket.OPEN) {
            Socket.ws.send(msgData.buffer)
          }
        }
      }, 4000);
    }
  },
  close() {
    if (Socket.heartbeatTime2) {
      clearInterval(Socket.heartbeatTime2);
    }
    if (Socket.hearbeatTime) {
      clearInterval(Socket.hearbeatTime);
    }
  }
};
export default Socket;
